export const initialRegistrationForm = {
  email: '',
  password: '',
  passwordConfirmation: '',
};
